module.exports = __webpack_public_path__ + "static/media/gasCorrect.d034d126.png";